/* eslint-disable */
/* https://github.com/alanbo/animate.js/tree/master/src/easings */
export default function (t, b, c, d) {
	t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};
